/* PRISKEL REDESIGN — header behaviour */
(function () {
  function init() {
    var hd = document.getElementById('pk-hd');
    if (!hd || hd.dataset.pkReady) return;
    hd.dataset.pkReady = '1';
    var root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* header height vars for sticky elements elsewhere */
    var ann = hd.querySelector('[data-pk-ann]');
    var bar = hd.querySelector('[data-pk-bar]');
    function sizes() {
      var a = ann ? ann.offsetHeight : 0;
      root.style.setProperty('--pk-ann-h', a + 'px');
      root.style.setProperty('--header-height', bar.offsetHeight + 'px');
      root.style.setProperty('--header-height2', bar.offsetHeight + 'px');
    }
    sizes();
    /* phones fire resize while the address bar slides during scroll; only re-measure on real width changes */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; sizes(); } });

    /* compact on scroll */
    var desk = window.matchMedia('(min-width: 1100px)');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        /* desktop only, with a dead band so the shrinking header can't flip the state back and forth */
        var was = hd.classList.contains('is-compact'), y = window.scrollY;
        var c = desk.matches ? (was ? y > 24 : y > 120) : false;
        if (c !== was) {
          hd.classList.toggle('is-compact', c);
          setTimeout(sizes, 280);
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* offer bar rotation */
    if (ann) {
      var msgs = [].slice.call(ann.querySelectorAll('.pk-hd__ann-msg'));
      var i = 0, timer = null;
      function show(n) {
        msgs[i].hidden = true; msgs[i].classList.remove('is-on');
        i = (n + msgs.length) % msgs.length;
        msgs[i].hidden = false; msgs[i].classList.add('is-on');
      }
      function play() { if (msgs.length > 1 && !reduce) { stop(); timer = setInterval(function () { show(i + 1); }, 5000); } }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      var p = ann.querySelector('[data-pk-ann-prev]'), n = ann.querySelector('[data-pk-ann-next]');
      if (p) p.addEventListener('click', function () { show(i - 1); play(); });
      if (n) n.addEventListener('click', function () { show(i + 1); play(); });
      ann.addEventListener('mouseenter', stop);
      ann.addEventListener('mouseleave', play);
      ann.addEventListener('focusin', stop);
      play();
    }

    /* counts: hide when zero */
    function zero(el) { el.setAttribute('data-zero', (el.textContent || '').trim() === '0' || (el.textContent || '').trim() === '' ? '1' : '0'); }
    [].forEach.call(hd.querySelectorAll('.pk-hd__count'), function (el) {
      zero(el);
      new MutationObserver(function () { zero(el); }).observe(el, { childList: true, characterData: true, subtree: true });
    });

    /* desktop panels: hover intent + keyboard + touch */
    var items = [].slice.call(hd.querySelectorAll('[data-pk-item]'));
    function close(li) { li.classList.remove('is-open'); var a = li.querySelector('.pk-hd__a'); if (a) a.setAttribute('aria-expanded', 'false'); }
    function open(li) { items.forEach(function (o) { if (o !== li) close(o); }); li.classList.add('is-open'); var a = li.querySelector('.pk-hd__a'); if (a) a.setAttribute('aria-expanded', 'true'); }
    items.forEach(function (li) {
      var t;
      li.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { open(li); }, 90); });
      li.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(function () { close(li); }, 160); });
      li.addEventListener('focusin', function () { open(li); });
      li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) close(li); });
      var a = li.querySelector('.pk-hd__a');
      a.addEventListener('click', function (e) {
        /* first tap on touch screens opens the panel; second tap follows the link */
        if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-open')) { e.preventDefault(); open(li); }
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') items.forEach(function (li) { if (li.classList.contains('is-open')) { close(li); li.querySelector('.pk-hd__a').focus(); } }); });
    document.addEventListener('click', function (e) { if (!hd.contains(e.target)) items.forEach(close); });

    /* mobile menu drawer */
    var menu = document.getElementById('pk-menu');
    var opener = hd.querySelector('[data-pk-menu-open]');
    if (menu && opener) {
      function openMenu() {
        if (typeof menu.showModal === 'function') menu.showModal(); else menu.setAttribute('open', '');
        root.classList.add('pk-lock');
        opener.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(function () { requestAnimationFrame(function () { menu.classList.add('is-in'); }); });
      }
      function closeMenu() {
        menu.classList.remove('is-in');
        opener.setAttribute('aria-expanded', 'false');
        setTimeout(function () { if (menu.open && typeof menu.close === 'function') menu.close(); else menu.removeAttribute('open'); root.classList.remove('pk-lock'); opener.focus(); }, reduce ? 0 : 280);
      }
      opener.addEventListener('click', openMenu);
      menu.querySelector('[data-pk-menu-close]').addEventListener('click', closeMenu);
      menu.addEventListener('cancel', function (e) { e.preventDefault(); closeMenu(); });
      menu.addEventListener('click', function (e) { if (e.target === menu) closeMenu(); });
      menu.addEventListener('close', function () { root.classList.remove('pk-lock'); menu.classList.remove('is-in'); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { var h = document.getElementById('pk-hd'); if (h) delete h.dataset.pkReady; init(); });
})();
